import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { loadUser } from 'src/app/shareModule/states/user-details/user-details.action';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-advanced-settings-verify',
  templateUrl: './advanced-settings-verify.component.html',
  styleUrls: [
    './advanced-settings-verify.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsVerifyComponent implements OnInit {

  public userInfo: any;
  public showVerificationTelegram = false;
  public userCard: any = false;
  public email: string = '';
  public currentEmail: string = '';
  public otp: string = '';
  public passcode: string = '';
  public isLoading: boolean = false;
  public otpSent: boolean = false;
  public delaySendOTP: number = 0;

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private customerService: CustomerService,
    private notificationService: MemberNotificationService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.store.pipe(select(selectUser)).subscribe((response: any) => {
      try {
        if (response) {
          const data = response;

          this.userInfo = {
            isVerified: data.isVerified,
            phone: data.phone,
            isEmailVerify: data.isEmailVerify,
          };

          this.cdr.detectChanges();
          this.appRef.tick();
        }
      } catch (error) {
        console.log("error", error, "PROFILE")
      }
    });
  }

  ngAfterViewInit(): void {
    this.store.dispatch(loadUser({}));
  }

  selectedOTP: any = '';
  modalRef: any = null;
  public openModal(modal: any) {
    this.selectedOTP = '';
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'otp-verification my-modal sm',
    });
  }


  public verifyEmailOtp() {
    if (this.selectedOTP && this.selectedOTP.length == 6) {
      this.customerService
        .verifyEmailOtp({
          otp: this.selectedOTP,
          email: this.userInfo.email,
        })
        .subscribe(
          (resp: ApiResponse) => {
            if (resp.message) {
              this.notificationService.notifyUser('Email', resp.message);
              this.modalRef ? this.modalRef.close() : '';
              this.store.dispatch(loadUser({}));
            }
          },
          ({ error }) => {
            this.toastr.error(error.message);
          }
        );
    } else {
      this.toastr.error('Invalid OTP!');
    }
  }


  async onChangeOtp(e: any) {
    this.otp = e.target.value;
  }

  async onChangePasscode(e: any) {
    this.passcode = e.target.value;
  }


  async sendOtp(modal = null) {
    this.isLoading = true;

    const length = 6;
    const otp = Array.from({ length }, () =>
      Math.floor(Math.random() * 10)
    ).join('');

    const data = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: `${this.userInfo.countryCode}${this.userInfo.phone}`,
      type: 'template',
      template: {
        name: 'user_otp',
        language: {
          code: 'en_US',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                text: otp,
              },
            ],
          },
          {
            type: 'button',
            sub_type: 'url',
            index: '0',
            parameters: [
              {
                type: 'text',
                text: otp,
              },
            ],
          },
        ],
      },
    };

    const token = environment.whtsappCloudToken;

    await fetch(environment.whtsappCloudUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    this.http
      .post(environment.baseUrlAdmin + 'member_save_otp_marketplace', {
        phoneNumber: this.userInfo?.phone,
        otp,
      })
      .subscribe()

    this.isLoading = false;
    this.otpSent = true;

    return true;
  }


  public sendEmailOtp() {
    if (this.delaySendOTP < 1)
      this.customerService
        .saveMemberEmail({
          email: this.email,
        })
        .subscribe(
          (resp: any) => {
            this.toastr.success(resp.message);
            this.store.dispatch(loadUser({}));
            this.delaySendOTP = 61;
            let interval = setInterval(() => {
              this.delaySendOTP -= 1;
              if (this.delaySendOTP == 0) {
                clearInterval(interval);
              }
              this.cdr.detectChanges();
            }, 1000);
          },
          ({ error }) => {
            this.toastr.error(error.message);
          }
        );
  }

  public async handleRemoveCard() {
    this.customerService
      .removeCard({
        type: 'user',
      })
      .subscribe(
        (resp: any) => {
          if (resp.message.trim() == 'Card Removed.') {
            this.userCard = false;
            this.toastr.success(resp.message);
            this.modalRef ? this.modalRef.close() : '';
          } else {
            this.toastr.error(resp.message);
          }
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }
}
